import { makeStyles } from 'tss-react/mui'

/**
 * Shared by every field that renders the ~85px unit/suffix adornment box (see the
 * `suffix` style next to each field's endAdornment). MUI's floating label and the
 * border's notch don't know that box exists, so left alone the label renders on top
 * of it and the border's notch (sized from a hidden <legend> mirroring the label's
 * *untruncated* text) stays wide enough to reach into it too. This keeps both in
 * sync: the label truncates with an ellipsis before the suffix box, and the notch is
 * capped to the same boundary (plus 10px slack for the "…" glyph, since text-overflow
 * renders it right at the label's truncation edge) so it lands under the truncated
 * text only — never open across the suffix, never cutting through the label itself.
 * Scoped to the shrink sibling so the resting state (no notch at all) is untouched.
 */
export const useSuffixFieldStyles = makeStyles()(() => ({
  // eslint-disable-next-line tss-unused-classes/unused-classes -- consumed by callers of this shared hook
  suffixField: {
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      // maxWidth is measured before the theme's shrink transform (translate(14px) scale(0.78))
      // is applied, so it's divided by 0.78 to make the truncation boundary land on-screen where intended.
      maxWidth: 'calc((100% - 99px) / 0.78)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink ~ .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend': {
      maxWidth: 'calc(100% - 75px)',
    },
  },
}))
